<h2 mat-dialog-title>Assign Multiple Zones</h2>
<div mat-dialog-content>
  <p>These changes will be applied to each selected day, check each day’s changes before confirming the updates.</p>
  <rspl-zone-lookup
    [currentId]="zone?.id"
    (onItemSelected)="selectZone($event)"
    [showSearchIcon]="false"
    label="Select a Zone to Apply"
    [filters]="{ partner_vehicle: data.parentId }"
    [required]="true"
  ></rspl-zone-lookup>
  <div fxLayout="column" fxLayoutGap="10px">
    <div>
      <button (click)="updateSavedZones()" class="primary-btn" mat-raised-button>
        <div fxLayout="row" fxLayoutGap="5px">
          <span>Update saved Zones</span>
          <mat-icon>open_in_new</mat-icon>
        </div>
      </button>
    </div>
    <div>
      <mat-checkbox [ngModel]="allSelected" color="primary" (change)="toggleAll()">Select all days</mat-checkbox>

      <div>
        <table class="full-width">
          <tbody>
            @for (day of listOfDays; track day) {
              <tr class="day">
                <td>
                  <mat-checkbox [checked]="days[day]" color="primary" (change)="days[day] = !days[day]" class="day-checkbox">
                    {{ day }}
                  </mat-checkbox>
                </td>
                <td>
                  <div fxLayout="column">
                    <label class="change-label">Adding</label>
                    <span [ngClass]="{ zero: changes[day].plus === 0 }">
                      <span [ngClass]="{ success: changes[day].plus > 0 }">
                        {{ changes[day].plus > 0 ? `+${changes[day].plus}` : '0' }}
                      </span>
                      zip codes
                    </span>
                  </div>
                </td>
                <td>
                  <div fxLayout="column">
                    <label class="change-label">Removing</label>
                    <span [ngClass]="{ zero: changes[day].minus === 0 }">
                      <span [ngClass]="{ error: changes[day].minus > 0 }">
                        {{ changes[day].minus > 0 ? `-${changes[day].minus}` : '0' }}
                      </span>
                      zip codes
                    </span>
                  </div>
                </td>
                <td>
                  <div fxLayoutAlign="end center">
                    <button [disabled]="!zone" mat-button color="primary" (click)="preview(changes[day], day)">Preview changes</button>
                  </div>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
<div mat-dialog-actions fxLayout="row" fxLayoutAlign="flex-end">
  <button mat-button (click)="close()">Back</button>
  <button class="primary-btn filled-btn" mat-raised-button rsplDisableDoubleClick (oneClick)="save()" [disabled]="!zone || !anySelected">
    Save
  </button>
</div>
